/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const FavoriteFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M11.9999 1.5C12.1983 1.5 12.3782 1.6172 12.4579 1.79883L15.3105 8.30176L22.0615 9.14355C22.2522 9.16734 22.4124 9.29819 22.4736 9.48047C22.5347 9.66274 22.4864 9.86403 22.3486 9.99805L17.3408 14.8662L18.6718 21.9072C18.7082 22.1 18.6282 22.2964 18.4677 22.4092C18.3072 22.5219 18.0957 22.5301 17.9267 22.4307L11.9999 18.9424L6.07318 22.4307C5.90417 22.5301 5.69262 22.5219 5.53216 22.4092C5.37172 22.2964 5.29169 22.1 5.32806 21.9072L6.65814 14.8662L1.6513 9.99805C1.51348 9.86403 1.46518 9.66273 1.5263 9.48047C1.58745 9.2982 1.74764 9.16734 1.93841 9.14355L8.68841 8.30176C9.14485 7.26128 9.60209 6.22114 10.0585 5.18066C10.553 4.05359 11.0475 2.92591 11.5419 1.79883L11.5761 1.73438C11.6666 1.58994 11.8261 1.50001 11.9999 1.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
